module.exports = __webpack_public_path__ + "static/media/scanSound.d932c606.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/sounds/scanSound.mp3
// module id = 3190
// module chunks = 0